import React from 'react';
import Images from '../utils/Images';

export const ADDON_SIZE_HEIGHTS = {
  small: 26,
  medium: 42,
  big: 62,
};

const getAddonValueText = (addonValue) =>
  [
    addonValue?.value,
    addonValue?.subLabel,
    addonValue?.label,
    addonValue?.iconInfo?.name,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

export const isSizeAddonGroup = (addon, values = []) => {
  if (/size/i.test(addon?.title || '')) return true;
  return values.some((value) =>
    /\b(small|medium|large|big|regular|regular_drink|medium_drink|large_drink)\b/.test(getAddonValueText(value))
  );
};

export const getAddonSizeTier = (addonValue, index = 0, total = 0) => {
  const text = getAddonValueText(addonValue);

  if (/\b(small|regular|sm|regular_drink)\b/.test(text) || text === 's') return 'small';
  if (/\b(medium|med|md|medium_drink)\b/.test(text) || text === 'm') return 'medium';
  if (/\b(large|big|lg|grande|large_drink)\b/.test(text) || text === 'l') return 'big';

  if (total >= 3) {
    if (index === 0) return 'small';
    if (index === total - 1) return 'big';
    return 'medium';
  }

  return 'medium';
};

const AddonIconComponent = ({ iconInfo, selected }) => {
  let iconSrc;
  let sizeTier = 'medium';

  switch (iconInfo.name) {
    case 'regular_drink':
      iconSrc = selected ? Images.drinkSmallSelected : Images.drinkSmall;
      sizeTier = 'small';
      break;
    case 'medium_drink':
      iconSrc = selected ? Images.drinkMediumSelected : Images.drinkMedium;
      sizeTier = 'medium';
      break;
    case 'large_drink':
      iconSrc = selected ? Images.drinkLargeSelected : Images.drinkLarge;
      sizeTier = 'big';
      break;
    default:
      return null;
  }

  return (
    <img
      className={`addonSizeIcon size-${sizeTier}`}
      style={{
        cursor: 'pointer',
        height: ADDON_SIZE_HEIGHTS[sizeTier],
        width: 'auto',
        objectFit: 'contain',
      }}
      src={iconSrc}
      alt={`${iconInfo.name} icon`}
    />
  );
};

export default AddonIconComponent;
